export enum UserType {
  INTERNAL = 1,
  EXTERNAL
}
